import {
  gnenumPATHROOTDEFAULT as PATHROOTDEFAULT
} from './gnenum.js'

import {
  gnerrPathOnRootInvalid as errPathOnRootInvalid
} from './gnerr.js'

const dummydomain = new URL('http://dummy.com')
const endwordre = /[ /.]*$/ // matches end '/' @ /my/full/path/
const slcharcode = 47

const gnpathJoin = (basepath, subpath) => {
  const basepathdir = basepath === '/' ? basepath : basepath + '/'
  const pathname = new URL(
    './' + subpath, new URL(basepathdir, dummydomain)).pathname

  return (basepath.charCodeAt(0) === slcharcode)
    ? pathname
    : pathname.slice(1)
}

const gnpathRootlen = PATHROOTDEFAULT.length

const gnpathOnRootIsValid = pathonroot => (
  typeof pathonroot === 'string'
    && pathonroot.startsWith(PATHROOTDEFAULT))

// currently assumes posix-path
// ex,
//
// ('$ROOTSPECS/spec/manifest.json', '/home/duck')
//  => '/home/duck/spec/manifest.json'
// ('$ROOTSPECS/spec/root/eng.json', '/home/duck/')
//  => '/home/duck/spec/root/eng.json'
// ('$ROOTSPECS/spec/root-guide/eng.json', '/home/duck')
//  => '/home/duck/spec/root-guide/eng.json'
const gnpathOnRootResolve = (pathonroot, pathroot, sep = '/') => {
  if (!gnpathOnRootIsValid(pathonroot))
    throw errPathOnRootInvalid(pathonroot)

  return (
    pathroot.endsWith(sep)
      ? pathroot.slice(0, -1)
      : pathroot) + pathonroot.slice(gnpathRootlen)
}

const gnpathRelResolve = (basepath, relpath) => {
  // if path ls /root/path... returns root
  if (relpath.charCodeAt(0) === slcharcode)
    return relpath

  if (relpath === './') {
    relpath = basepath
  } else {
    relpath = gnpathJoin(
      basepath.replace(endwordre, ''), relpath
    ).replace(endwordre, '')
  }

  return relpath
}

// return '/path/to' from '/path/to/node'
//
// if removing the 'last' path leaves an empty string ('/path' => '')
// return root path '/'
//
const gnpathlastre = /\/[^/]*$/

const gnpathParentDir = basepath => (
  basepath.replace(gnpathlastre, '') || '/')

export {
  gnpathOnRootIsValid,
  gnpathOnRootResolve,
  gnpathRelResolve,
  gnpathParentDir,
  gnpathJoin
}
